import React from "react";
import Style from "@assets/css/workshope.module.css";
import AssureStrip from "components/Home/assure-strip";
import MApView from "./map-view";
import WorkshopCard from "./workshop-card";
import AssureMobile from "./assure-mobile";
import { handleClassNames } from "lib/cssHelpers";
import { getLocationData, setLoader, toggleChooseCar } from "redux/actions/globalAction";
import {
  getCoordinates,
  getWorkshopAmenities,
  getWorkshopsJourneyCategory,
} from "redux/actions/apiActions";
import { useState } from "react";
import { usePlacesWidget } from "react-google-autocomplete";
import { connect } from "react-redux";
import { useEffect } from "react";

const Main = ({
  getLocationData,
  getCoordinates,
  getWorkshopsJourneyCategory,
  apiData,
  setLoader,
  toggleChooseCar
}) => {

  useEffect(() => {
    setLoader(false)
    toggleChooseCar(false)
  }, [])

  const handleClasses = (classValue) => {
    return handleClassNames(classValue, Style);
  };
  const [placeChanged, setPlaceChanged] = useState(null);
  const [hadLocation, setHadLocation] = useState(false)
  const { ref } = usePlacesWidget({
    apiKey: process.env.NEXT_PUBLIC_GOOGLE_MAP_KEY,
    onPlaceSelected: (place) => {
      setPlaceChanged(place);
    },
    options: {
      types: [],
      componentRestrictions: { country: "AE" },
    },
  });
  return (
    <main className={handleClasses("main-block")}>
      <div className={handleClasses("main-workshop-head")}></div>
      <AssureStrip />

      <MApView
        getLocationData={getLocationData}
        getCoordinates={getCoordinates}
        getWorkshopsJourneyCategory={getWorkshopsJourneyCategory}
        coordinatesData={apiData.coordinates}
        amenitiesData={apiData.amenities}
        workshopJourneyCategoryData={apiData.workshopJourneyCategory}
        getWorkshopAmenities={getWorkshopAmenities}
        ref={ref}
        placeChanged={placeChanged}
        hadLocation={hadLocation}
      />

      <WorkshopCard />

      <AssureMobile />
    </main>
  );
};
const mapStateToProps = (state) => {
  return {
    apiData: state.apiData,
    globalData: state.globalData,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    clearLoginData: () => {
      dispatch(clearLoginData());
    },
    getCoordinates: (lat, lang, size) => {
      dispatch(getCoordinates(lat, lang, size));
    },
    setLoader: (data) => {
      dispatch(setLoader(data));
    },
    getVariants: (id, mId) => {
      dispatch(getVariants(id, mId));
    },
    getWorkshopsJourneyCategory: (id) => {
      dispatch(getWorkshopsJourneyCategory(id));
    },
    getWorkshopAmenities: (id) => {
      dispatch(getWorkshopAmenities(id));
    },
    getTopSellingJob: (mId) => {
      dispatch(getTopSellingJob(mId));
    },
    getModel: (id) => {
      dispatch(getModel(id));
    },
    getUserAuth: (data) => {
      dispatch(getUserAuth(data));
    },
    getLocationData: (lat, lng, address) => {
      dispatch(getLocationData(lat, lng, address));
    },
    toggleChooseCar: (flag) => {
      dispatch(toggleChooseCar(flag))
    },
    getCarBrandModal: (
      brand,
      modal,
      logoBrand,
      logoModal,
      brandId,
      modelId,
      slug = null
    ) => {
      dispatch(
        getCarBrandModal(
          brand,
          modal,
          logoBrand,
          logoModal,
          brandId,
          modelId,
          slug
        )
      );
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Main);
